/**
 * Lo que se escribe en una casilla de número, limpio: con punto y sin letras.
 *
 * ═══════════════════════════════════════════════════════════════════════════
 *  ⚠️ EL FALLO QUE ESTO ARREGLA: EL IPHONE NO DEJABA PONER DECIMALES
 * ═══════════════════════════════════════════════════════════════════════════
 *
 * Un iPhone en español enseña, en su teclado numérico, la COMA y no el punto.
 * Y una casilla `<input type="number">` solo entiende el punto: la coma no
 * entraba. No había forma de escribir «1,50» — ni un precio con céntimos, ni una
 * tasa. El dueño lo vio creando un producto desde el teléfono.
 *
 * Por eso las casillas de número son de texto por dentro (ver `Campo`) y lo que
 * se teclea pasa por aquí: la coma se vuelve punto y lo demás se descarta.
 *
 * ⚠️ Si vienen coma Y punto —«1.234,56», pegado de otro sitio—, el ÚLTIMO de los
 * dos es el decimal y el resto son separadores de miles. Así se escribe en
 * Venezuela y en Colombia, y así lo lee cualquiera.
 */
export function normalizarDecimal(
  texto: string,
  { negativo = true, decimales = true }: { negativo?: boolean; decimales?: boolean } = {},
): string {
  const sinEspacios = texto.replace(/\s/g, "");
  const conSigno = negativo && sinEspacios.startsWith("-");
  let limpio = sinEspacios.replace(/[^\d.,]/g, "");

  if (!decimales) {
    limpio = limpio.replace(/[.,]/g, "");
  } else {
    const separador = Math.max(limpio.lastIndexOf(","), limpio.lastIndexOf("."));
    if (separador >= 0) {
      const entero = limpio.slice(0, separador).replace(/[.,]/g, "");
      const fraccion = limpio.slice(separador + 1).replace(/[.,]/g, "");
      limpio = `${entero}.${fraccion}`;
    }
  }
  return (conSigno ? "-" : "") + limpio;
}
